import { styled } from "styled-components";

import { Image, SourceLabel } from "common/components";
import { breakpoints } from "common/styles";
import { useTranslate } from "common/utilities/useTranslate";
import type { Source } from "entities/knowledge/types";

const StyledImage = styled(Image)`
  height: 200px;
  border-radius: 4px;

  @media ${breakpoints.medium} {
    height: 250px;
  }

  @media ${breakpoints.extraLarge} {
    height: 350px;
  }
`;

const StyledSourceLabel = styled(SourceLabel)`
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  font-size: 1rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.textBright};
`;

type ArticleDetailProps = { title: string; imageUrl?: string; source?: Source; timestamp: number };

export const ArticleDetail = ({ title, imageUrl, source, timestamp }: ArticleDetailProps) => {
  const translate = useTranslate();

  return (
    <>
      <StyledImage
        src={imageUrl}
        alt={`${translate("app.monitor.article.cover_image_alt_text")} ${title ?? "Article Image"}`}
      />
      {source && <StyledSourceLabel source={source} date={timestamp} type="small" />}
    </>
  );
};
